/**
 * Recipients API - операции с контактами кампании
 */
import apiClient from '../client';

/**
 * @typedef {Object} Recipient
 * @property {string} id
 * @property {string} email
 * @property {string} [name]
 * @property {string} status - PENDING | SENT | FAILED | RESPONDED
 * @property {string} [sentAt]
 * @property {Object} [lead]
 */

/**
 * Добавить контакты в кампанию
 * @param {string} campaignId
 * @param {Array<{email: string, name?: string}>} items
 * @returns {Promise<{ added: Recipient[], campaign: Object }>}
 */
export async function addRecipients(campaignId, items) {
  const { data } = await apiClient.post(`/outreach/campaigns/${campaignId}/recipients/bulk`, {
    items
  });
  return {
    added: data.added || [],
    campaign: data.campaign
  };
}

/**
 * Удалить контакт из кампании
 * @param {string} campaignId
 * @param {string} recipientId
 * @returns {Promise<void>}
 */
export async function removeRecipient(campaignId, recipientId) {
  await apiClient.delete(`/outreach/campaigns/${campaignId}/recipients/${recipientId}`);
}

/**
 * Прикрепить базу контактов к кампании
 * @param {string} campaignId
 * @param {string} listId
 * @returns {Promise<Object>}
 */
export async function attachContactList(campaignId, listId) {
  const { data } = await apiClient.post(`/outreach/campaigns/${campaignId}/contact-lists`, {
    listId
  });
  return data;
}

/**
 * Открепить базу контактов от кампании
 * @param {string} campaignId
 * @param {string} listId
 * @returns {Promise<void>}
 */
export async function detachContactList(campaignId, listId) {
  await apiClient.delete(`/outreach/campaigns/${campaignId}/contact-lists/${listId}`);
}
